import classNames from 'classnames';
import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';

import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import type { QButtonProps } from 'components/QButtonNew';
import QButton from 'components/QButtonNew';
import { type SxProps, type Theme } from '@mui/material/styles';

const useStyles = makeStyles()((theme) => ({
  infoIcon: {
    marginLeft: 2,
    marginRight: 2,
    height: 18,
  },
  tooltipText: {
    color: theme.palette.error.main,
    display: 'flex',
    alignItems: 'center',
  },
  tooltip: {
    backgroundColor: theme.palette.error.light,
  },
  tooltipArrow: {
    color: theme.palette.error.light,
  },
  tooltipStyle: {
    padding: 12,
    borderRadius: 8,
  },
  popper: {
    marginBottom: '8px !important',
  },
}));

type placementType =
  | 'bottom'
  | 'left'
  | 'right'
  | 'top'
  | 'bottom-end'
  | 'bottom-start'
  | 'left-end'
  | 'left-start'
  | 'right-end'
  | 'right-start'
  | 'top-end'
  | 'top-start'
  | undefined;

export interface TooltipButtonProps extends QButtonProps {
  tooltipText?: any;
  buttonText?: string;
  children?: any;
  placement?: placementType;
  showTooltip?: boolean;
  tooltipSx?: SxProps<Theme>;
}
function TooltipSubmitButton(props: TooltipButtonProps) {
  const {
    tooltipText,
    buttonText,
    onClick,
    showTooltip,
    placement = 'top-end',
    disabled,
    children,
    tooltipSx,
    ...otherProps
  } = props;
  const { classes } = useStyles();
  const slotProps = tooltipSx ? { popper: { sx: tooltipSx } } : undefined;

  return (
    <Tooltip
      id='error-tooltip'
      placement={placement}
      slotProps={slotProps}
      classes={{
        tooltip: classNames(classes.tooltip, classes.tooltipStyle),
        arrow: classes.tooltipArrow,
        tooltipPlacementTop: classes.popper,
      }}
      open={showTooltip}
      arrow
      title={
        Array.isArray(tooltipText) ? (
          tooltipText.map((text) => (
            <div key={text} className={classes.tooltipText}>
              <ErrorIcon className={classes.infoIcon} />
              <Typography variant='paragraphRegular'>{text}</Typography>
            </div>
          ))
        ) : (
          <div className={classes.tooltipText}>
            <ErrorIcon className={classes.infoIcon} />
            <Typography variant='paragraphRegular'>{tooltipText || 'Form fields need attention'}</Typography>
          </div>
        )
      }
    >
      <QButton variant='contained' onClick={onClick} disabled={disabled} {...otherProps}>
        {buttonText || children}
      </QButton>
    </Tooltip>
  );
}

export default memo(TooltipSubmitButton);
